<template>
  <div
    v-if="loading"
    class="w-full h-full flex items-center justify-center"
  >
    <b-spinner
      class="ml-2"
      variant="primary"
      size="xl"
    />
  </div>
  
  <div
    v-else
    class="flex flex-col w-full"
  >
    <h1 class="text-xl font-semibold text-black mb-0">
      DDoS
    </h1>

    <div class="bg-white w-full border border-[#D7D7D7] shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] p-8 rounded-[5px] mt-3">
      <h3 class="text-lg font-semibold">
        DDoS protection
      </h3>
      <p class="text-base text-[#6E747A] mt-[10px]">
        Your domain is now fully protected with ESTAGE Advanced DDoS mitigation system that detects, blocks, and stops malicious requests before they ever reach your site.
      </p>
    </div>

    <b-alert
      v-if="awsConnected"
      show
      variant="info"
      class="mb-3 mt-2 shadow-[0_1px_3px_0_rgba(0,0,0,0.1)]"
    >
      <b>Note: </b>
      <span>Your domain security and DDoS mitigation is covered and automatically managed by the ESTAGE platform via AWS. These statistics are reflecting a global server data that includes all projects on the platform.</span>
    </b-alert>

    <div
      v-if="awsConnected"
      class="grid grid-cols-1 lg:grid-cols-3 gap-3"
    >
      <div class="bg-white w-full border border-[#D7D7D7] shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] p-8 rounded-[5px] mt-3 flex flex-col gap-[10px]">
        <h3 class="text-base text-black font-semibold mb-0">
          Allowed Requests
          <!--          <b-btn-->
          <!--            v-b-tooltip.hover.bottom-->
          <!--            variant="text"-->
          <!--            title="The number of labels on web requests that had the action setting Allow applied. The labels can have been added at any point during the web request evaluation."-->
          <!--            class="p-0 m-0"-->
          <!--          >-->
          <!--            <i-->
          <!--              aria-hidden="true"-->
          <!--              class="fa fa-info-circle text-sm"-->
          <!--            />-->
          <!--          </b-btn>-->
        </h3>
        <p class="text-2xl text-[#393939] font-semibold mb-0">
          {{ metrics.ddos.allowedRequests }}
        </p>
      </div>
      <div class="bg-white w-full border border-[#D7D7D7] shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] p-8 rounded-[5px] mt-3 flex flex-col gap-[10px]">
        <h3 class="text-base text-black font-semibold mb-0">
          Challenged Requests
          <!--          <b-btn-->
          <!--            v-b-tooltip.hover.bottom-->
          <!--            variant="text"-->
          <!--            title="The number of labels added to web requests by rule group rules that have a Count action setting."-->
          <!--            class="p-0 m-0"-->
          <!--          >-->
          <!--            <i-->
          <!--              aria-hidden="true"-->
          <!--              class="fa fa-info-circle text-sm"-->
          <!--            />-->
          <!--          </b-btn>-->
        </h3>
        <p class="text-2xl text-[#393939] font-semibold mb-0">
          {{ metrics.ddos.challengedRequests }}
        </p>
      </div>
      <div class="bg-white w-full border border-[#D7D7D7] shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] p-8 rounded-[5px] mt-3 flex flex-col gap-[10px]">
        <h3 class="text-base text-black font-semibold mb-0">
          Blocked Requests
          <!--          <b-btn-->
          <!--            v-b-tooltip.hover.bottom-->
          <!--            variant="text"-->
          <!--            title="The number of labels on web requests that had the action setting Block applied. The labels can have been added at any point during the web request evaluation."-->
          <!--            class="p-0 m-0"-->
          <!--          >-->
          <!--            <i-->
          <!--              aria-hidden="true"-->
          <!--              class="fa fa-info-circle text-sm"-->
          <!--            />-->
          <!--          </b-btn>-->
        </h3>
        <p class="text-2xl text-[#393939] font-semibold mb-0">
          {{ metrics.ddos.blockedRequests }}
        </p>
      </div>
    </div>
    
    <div
      v-else
      class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-3"
    >
      <div class="bg-white w-full border border-[#D7D7D7] shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] p-8 rounded-[5px] mt-3 flex flex-col gap-[10px]">
        <h3 class="text-base text-black font-semibold mb-0">
          DDoS Mitigated
        </h3>
        <p class="text-2xl text-[#393939] font-semibold mb-0">
          {{ metrics.ddos.blockedRequests }}
        </p>
      </div>
      <div class="bg-white w-full border border-[#D7D7D7] shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] p-8 rounded-[5px] mt-3 flex flex-col gap-[10px]">
        <h3 class="text-base text-black font-semibold mb-0">
          DDoS Logged
        </h3>
        <p class="text-2xl text-[#393939] font-semibold mb-0">
          {{ metrics.ddos.loggedRequests }}
        </p>
      </div>
      <div class="bg-white w-full border border-[#D7D7D7] shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] p-8 rounded-[5px] mt-3 flex flex-col gap-[10px]">
        <h3 class="text-base text-black font-semibold mb-0">
          Challenges Served
        </h3>
        <p class="text-2xl text-[#393939] font-semibold mb-0">
          {{ metrics.ddos.challengedRequests }}
        </p>
      </div>
      <div class="bg-white w-full border border-[#D7D7D7] shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] p-8 rounded-[5px] mt-3 flex flex-col gap-[10px]">
        <h3 class="text-base text-black font-semibold mb-0">
          Challenges Verified
        </h3>
        <p class="text-2xl text-[#393939] font-semibold mb-0">
          {{ metrics.ddos.verifiedRequests }}
        </p>
      </div>
    </div>

    <div class="bg-white w-full border border-[#D7D7D7] shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] p-8 rounded-[5px] mt-3 flex flex-col gap-[10px]">
      <h3 class="text-lg text-black font-semibold mb-3">
        Threat Activity
      </h3>

      <apexchart
        type="area"
        height="350"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import {mapState} from 'vuex'
export default {
  name: 'DomainDdosMigration',
  components: {
    apexchart: VueApexCharts
  },
  data () {
    return {
      loading: false,
      metrics: {
        ddos: {
          allowedRequests: 0,
          blockedRequests: 0,
          challengedRequests: 0,
          loggedRequests: 0,
          verifiedRequests: 0
        },
        activity: {}
      },
      series: [],
      chartOptions: {
        chart: {
          id: 'threat-activity',
          type: 'line',
          toolbar: {
            show: false
          }
        },
        colors: ['#4F83E3', '#23CD59', '#F2A710', '#EB4949'],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: 1.5
        },
        xaxis: {
          categories: [],
          tickAmount: 8,
          labels: {
            rotate: -45,
            style: {
              colors: '#475467',
              fontSize: '12px'
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              colors: '#475467',
              fontSize: '12px'
            }
          }
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right'
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'vertical',
            opacityFrom: 0.4,
            opacityTo: 0.1
          }
        },
        tooltip: {
          theme: 'light',
          style: {
            fontSize: '14px',
            fontFamily: 'Inter, sans-serif'
          },
          x: {
            format: 'dd MMM'
          },
          y: {
            formatter: function (value) {
              return value.toLocaleString()
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapState('projects', {
      project: state => state.project
    }),
    awsConnected () {
      return this.project?.aws_data?.certificate_arn
    }
  },
  methods: {
    formatNumber (num) {
      return num.toLocaleString('en-US', {
        notation: 'compact',
        compactDisplay: 'short',
        maximumFractionDigits: 3
      })
    },
    async fetchMetrics () {
      this.loading = true
      if (this.awsConnected) {
        this.series = [
          {
            name: 'Allowed',
            data: []
          },
          {
            name: 'Challenged',
            data: []
          },
          {
            name: 'Blocked',
            data: []
          }
        ]
        const {data: AllowedRequests} = await axios.get(`https://new-api.estage.com/api/projects/${this.project.id}/cloud-front/statistics?metric=AllowedRequests`)
        const {data: CountedRequests} = await axios.get(`https://new-api.estage.com/api/projects/${this.project.id}/cloud-front/statistics?metric=CountedRequests`)
        const {data: BlockedRequests} = await axios.get(`https://new-api.estage.com/api/projects/${this.project.id}/cloud-front/statistics?metric=BlockedRequests`)

        const allowedByHour = AllowedRequests.data.map(item => ({
          hour: moment(item.Timestamp).format('HH:00'),
          sum: item.Sum || 0
        }))
        allowedByHour.sort((a, b) => parseInt(a.hour) - parseInt(b.hour))
        allowedByHour.forEach(item => {
          this.chartOptions.xaxis.categories.push(item.hour)
          this.series[0].data.push(item.sum)
        })

        const countedByHour = CountedRequests.data.map(item => ({
          hour: moment(item.Timestamp).format('HH:00'),
          sum: item.Sum || 0
        }))
        countedByHour.sort((a, b) => parseInt(a.hour) - parseInt(b.hour))
        countedByHour.forEach(item => {
          this.series[1].data.push(item.sum)
        })

        const blockedByHour = BlockedRequests.data.map(item => ({
          hour: moment(item.Timestamp).format('HH:00'),
          sum: item.Sum || 0
        }))
        blockedByHour.sort((a, b) => parseInt(a.hour) - parseInt(b.hour))
        blockedByHour.forEach(item => {
          this.series[2].data.push(item.sum)
        })

        const AllowedRequestsSum = AllowedRequests.data.reduce((acc, cur) => acc + (cur.Sum || 0), 0)
        const CountedRequestsSum = CountedRequests.data.reduce((acc, cur) => acc + (cur.Sum || 0), 0)
        const BlockedRequestsSum = BlockedRequests.data.reduce((acc, cur) => acc + (cur.Sum || 0), 0)

        this.metrics = {
          ddos: {
            allowedRequests: this.formatNumber(AllowedRequestsSum),
            blockedRequests: this.formatNumber(BlockedRequestsSum),
            challengedRequests: this.formatNumber(CountedRequestsSum)
          },
          activity: {}
        }
        this.loading = false
      } else {
        this.series = [
          {
            name: 'Logged',
            data: []
          },
          {
            name: 'Blocked',
            data: []
          },
          {
            name: 'Challenged',
            data: []
          },
          {
            name: 'Verified',
            data: []
          }
        ]
        const {data} = await axios.get(`api/projects/${this.project.id}/bunny-shield-metrics`)
        const overview = data.data.data.dDoSOverviewPastTwentyEightDays || {}
        Object.entries(overview).reduce((acc, [date, values]) => {
          this.chartOptions.xaxis.categories.push(moment(date, 'DD-MM-YYYY').format('DD MMM'))
          this.series[0].data.push(values.loggedRequests || 0)
          this.series[1].data.push(values.blockedRequests || 0)
          this.series[2].data.push(values.challengedRequests || 0)
          this.series[3].data.push(values.verifiedRequests || 0)
        }, {})
        this.metrics = {
          ddos: data.data.data.dDoS,
          activity: overview
        }
        this.loading = false
      }
    }
  },
  async mounted () {
    await this.$store.dispatch('projects/hasAccessToPage', 'domain_management')
    await this.fetchMetrics()
  }
}
</script>

<style>
#apexchartsthreat-activity {
  width: 100% !important;
}

.apexcharts-svg {
  width: 100%;
}
</style>
